import React from 'react';
import PrintErrorMessage from '@/components/organisms/feedback/PrintErrorMessage';
import PrintInformationMessage from '@/components/organisms/feedback/PrintInformationMessage';
import FormNewExpense from '@/components/macro-organisms/tabs/consultant-vision-user/expense-account/formNewExpense';
import FormNewPayslip from '@/components/macro-organisms/panels/panels-admin/NewPayslip/FormNewPayslip';
import FormEditBills from '@/components/macro-organisms/panels/panels-admin/Bills/FormEditBills';
import FormNewCompanyBenefit from '@/components/macro-organisms/panels/panels-admin/newCompanyBenefit/FormNewCompanyBenefit';
import StatementOperationForm from '@/components/macro-organisms/tabs/consultants-vision-admin/overflow/StatementOperationForm';
import StatementOperationAlwaysEditableForm from '@/components/macro-organisms/tabs/consultants-vision-admin/overflow/StatementOperationAlwaysEditableForm';

export default function EditOperationFormContent({
    editMode,
    editingOperation,
    alwaysEditableForm,
    setAlwaysEditableForm,
    submissionError,
    editOperationForm,
    setEditOperationForm,
    currencies,
    loadingCurrencies,
    errorCurrencies,
    t,
    getSelectedEntityHookData,
    handleSubmitTypedForm,
    submitRef,
    submissionSuccess,
    setSubmissionSuccess,
    setSubmissionError,
}) {
    if (editMode === 'alwaysEditable') {
        return (
            <StatementOperationAlwaysEditableForm
                alwaysEditableForm={alwaysEditableForm}
                setAlwaysEditableForm={setAlwaysEditableForm}
                submissionError={submissionError}
            />
        );
    }

    if (editMode === 'manualForm') {
        return (
            <StatementOperationForm
                formData={editOperationForm}
                setFormData={setEditOperationForm}
                currencies={currencies}
                loadingCurrencies={loadingCurrencies}
                errorCurrencies={errorCurrencies}
                t={t}
                submissionError={submissionError}
            />
        );
    }

    const selected = getSelectedEntityHookData();
    if (selected.loading) return <span className="loader" />;
    if (selected.error) return <PrintErrorMessage error={selected.error} />;

    if (editingOperation.operationType === 'EXPENSE_REPORT') {
        return (
            <FormNewExpense
                data={selected.data}
                forEdition
                isForApprovalUseCase={false}
                onSubmit={handleSubmitTypedForm}
                submitRef={submitRef}
                submissionSuccess={submissionSuccess}
                submissionError={submissionError}
                refetchFromScratch={() => {}}
                setSubmissionSuccess={setSubmissionSuccess}
                setSubmissionError={setSubmissionError}
                setEditFile={() => {}}
                setDisabledButtons={() => {}}
            />
        );
    }

    if (editingOperation.operationType === 'PAYSLIP') {
        return (
            <FormNewPayslip
                global
                data={selected.data}
                forEdition
                onSubmit={handleSubmitTypedForm}
                submitRef={submitRef}
                submissionSuccess={submissionSuccess}
                submissionError={submissionError}
            />
        );
    }

    if (editingOperation.operationType === 'CONSULTANT_INVOICE') {
        return (
            <FormEditBills
                global={false}
                disabledDeletion
                submitRef={submitRef}
                onSubmit={handleSubmitTypedForm}
                editData={selected.data}
                submissionSuccess={submissionSuccess}
                submissionError={submissionError}
                setChangeContent={() => {}}
            />
        );
    }

    if (editingOperation.operationType === 'COMPANY_BENEFIT_INVOICE') {
        return (
            <FormNewCompanyBenefit
                data={selected.data}
                forEdition
                onSubmit={handleSubmitTypedForm}
                submitRef={submitRef}
                submissionSuccess={submissionSuccess}
                submissionError={submissionError}
                setSubmissionError={setSubmissionError}
                setSubmissionSuccess={setSubmissionSuccess}
            />
        );
    }

    return <PrintInformationMessage information={`Edition en stand-by pour ${editingOperation.operationType}`} />;
}